import axios from "axios";
import session from "./session";

const getClient = (baseUrl = null) => {
  const options = {
    baseURL: baseUrl,
    withCredentials: true,
  };

  const client = axios.create(options);

  // request error interceptor
  client.interceptors.request.use(
    (requestConfig) => {
      if (session.isAuthenticated()) {
        requestConfig.headers.Authorization = `Bearer ${session.getAccessToken()}`;
      }
      return requestConfig;
    },
    (requestError) => {
      // intercept errors here

      return Promise.reject(requestError);
    }
  );

  // response error interceptor
  client.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (error.response?.status === 401) {
        session.clear();
        window.location.reload();
      }
      if (typeof error.response?.data !== "undefined") {
        return Promise.reject(error.response.data);
      }

      return Promise.reject(error);
    }
  );

  return client;
};

export default class BaseApiClient {
  constructor(baseUrl = null) {
    this.client = getClient(baseUrl);
  }

  get(url, conf = {}) {
    return this.client
      .get(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  delete(url, conf = {}) {
    return this.client
      .delete(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  head(url, conf = {}) {
    return this.client
      .head(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  options(url, conf = {}) {
    return this.client
      .options(url, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  post(url, data = {}, conf = {}) {
    return this.client
      .post(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  put(url, data = {}, conf = {}) {
    return this.client
      .put(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }

  patch(url, data = {}, conf = {}) {
    return this.client
      .patch(url, data, conf)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error));
  }
}
